import { app } from '../../../../app';
import { Controller } from './add-active-directory.controller';

app.component('companyDirectoryIntegrationAddActiveDirectory', {
    bindings: {
        companyId: '<',
        directories: '<',
    },
    controller: Controller,
    templateUrl: require('./add-active-directory.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/add/add-active-directory.component.js